<template>
  <div class="escalar mx-auto">
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card class="mx-auto" width="200">
          <div>
            <a class="imgContainer" :href="productDetail(product.code)">
              <v-img
                class="img primary--text align-end"
                contain
                :src="image(product.image)"
              >
                <v-fade-transition>
                  <v-overlay
                    v-if="
                      (hover && product.related) || (hover && product.similar)
                    "
                    absolute
                    color="#FFB74D"
                  >
                    <H2
                      v-if="product.related && product.comments != null"
                      class="pa-1 blue--text text--darken-4"
                    >
                      Comentarios del especialista:
                    </H2>

                    <H2
                      v-if="product.similar && product.comments != ''"
                      class="pa-1 blue--text text--darken-4"
                    >
                      Comentarios:
                    </H2>

                    <h3 class="pa-1 blue--text text--darken-4">
                      {{ product.comments }}
                    </h3>
                  </v-overlay>
                </v-fade-transition>
              </v-img>
            </a>
          </div>

          <v-card-title class="itemDescription padding">
            {{ product.brand.name }}
          </v-card-title>

          <div class="productTitle">
            <v-tooltip
              v-if="showTooltip(product.description)"
              max-width="220"
              top
            >
              <template v-slot:activator="{ on }">
                <v-card-text class="padding">
                  <a
                    v-on="on"
                    class="description-"
                    :href="productDetail(product.code)"
                  >
                    <p>{{ productName(product.description) }}</p>
                  </a>
                </v-card-text>
              </template>

              <span>{{ product.description }}</span>
            </v-tooltip>

            <v-card-text
              v-if="!showTooltip(product.description)"
              class="padding"
            >
              <a class="description-" :href="productDetail(product.code)">
                <p>{{ productName(product.description) }}</p>
              </a>
            </v-card-text>
          </div>

          <div class="skuStyle">
            <v-card-text class="padding">
              <strong>Risoul #:</strong>
              {{ product.code }}
            </v-card-text>

            <v-card-text class="padding truncate">
              <strong>Parte #:</strong>
              {{ product.providerCode }}
            </v-card-text>

            <v-card-text class="padding">
              <div class="action-buttons">
                <btnExistencias
                  class="btn-existencias"
                  :itemId="product.itemId"
                >
                </btnExistencias>

                <v-btn
                  class="ml-5"
                  outlined
                  width="40"
                  @click="addCart(product)"
                  color="orange"
                >
                  <v-icon>add_shopping_cart</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </template>
    </v-hover>
  </div>
</template>

<script>
import btnExistencias from "./../child_btn_existencias.vue";

export default {
  name: "cardProducts",

  components: {
    btnExistencias,
  },

  data() {
    return {
      overlay: false,
    };
  },

  props: {
    product: { type: Object },
    addShoppingCart: { type: Function },
  },

  methods: {
    addCart: function (product) {
      product.quantity = 1;
      this.addShoppingCart(product);
    },

    productDetail(sku) {
      return `#/productDetail/${sku}`;
    },

    image: function (name) {
      var image = name.split(" ").join("+");
      return `https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/${image}`;
    },
    productName: function (name) {
      return name.length > 60 ? `${name.substring(0, 60)}...` : name;
    },

    showTooltip(name) {
      return name.length > 60;
    },
  },

  computed: {},

  watch: {},

  created: function () {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
.v-btn:not(.v-btn--round).v-size--default {
  height: 28px;
  padding: 0 4px;
}

.v-btn.v-size--default,
.v-btn.v-size--large {
  font-size: 1.2rem;
}

p {
  margin: 0;
  color: black;
  font-weight: 600;
  text-align: justify;
  line-height: 15px;
}

a {
  text-decoration: none;
}

.escalar:hover {
  transform: scale(1.03);
}

.img {
  /* width: 100%;
  height: auto;
  max-height: 250px; */
  height: 100%;
  width: auto;
  max-width: 200px;
}

.imgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 205px;
  height: 200px;
  /* border: black solid 1px; */
}

.itemDescription {
  font-size: 12px;
}

.padding {
  font-size: 12px;
  font-family: roboto;
  padding: 0 8px;
}

.productTitle {
  height: 45px;
  margin: 5px 0;
  line-height: 14px;
}

.skuStyle {
  max-height: 9.5rem;
}

.action-buttons {
  width: 180px;
  padding-bottom: 8px;
}

.truncate {
  max-width: 206px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.aviso {
  width: 20px;
  height: 300px;
  background: rgba(238, 117, 4, 0.993);
  position: absolute;
  top: -50px;
  left: 0;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  text-align: center;
  vertical-align: middle;
}

.aviso p {
  -webkit-transform: rotate(-100deg);
  -moz-transform: rotate(-100deg);
  -ms-transform: rotate(-100deg);
  -o-transform: rotate(-100deg);
  transform: rotate(-90deg);
  width: 150px;
  margin-left: 10px;
  padding-bottom: 150px;
  color: rgb(255, 255, 255);
  font-size: 12px;
}
</style>
